<!-- todo -->
<!-- input validation| formControl -->
<h2 mat-dialog-title>{{'printerclasses.addHeading' | translate}}</h2>
<mat-dialog-content>
  <mat-form-field appearance="fill" class="printrForm">
    <mat-label>{{'printerclasses.addName' | translate}}</mat-label>
    <input matInput placeholder="Regensdorf" [(ngModel)]="data.printerClassName" minlength="1" maxlength="30"
      required [formControl]="nameValidator">
      <mat-hint align="end">{{ data.printerClassName?.length || 0}}/30</mat-hint>
      @if (nameValidator.errors?.required) {
        <mat-error>{{'printerclasses.addNameRequired' | translate}}</mat-error>
      }
      @if (nameValidator.errors?.pattern) {
        <mat-error>{{'printerclasses.addNameValid' | translate}}</mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()">{{'printerclasses.addAbort' | translate}}</button>
    @if (!nameValidator.errors?.required && !nameValidator.errors?.pattern) {
      <button mat-raised-button color="primary" [mat-dialog-close]="data">{{'printerclasses.addButton' | translate}}</button>
    }
  </mat-dialog-actions>
